import React from "react";
import style from "../styles/home.module.css";
import Typewriter from "typewriter-effect";
import { motion } from "framer-motion";
import { AiFillLinkedin, AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { TbMapPin, TbArrowRight, TbDownload } from "react-icons/tb";
import { TechIcon } from "../components/techIcons";
import { profile, heroFlow } from "../data/profile";
import pdf from "./Images/Akil-Sadik-AI-Automation-Engineer-Resume.pdf";

const Home = () => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.09, delayChildren: 0.1 } },
  };
  const item = {
    hidden: { opacity: 0, y: 26 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.21, 0.6, 0.35, 1] } },
  };

  return (
    <header id="home" className={style.home}>
      {/* decorative animated glows */}
      <motion.span
        className={`${style.blob} ${style.blobA}`}
        animate={{ x: [0, 30, 0], y: [0, -20, 0], scale: [1, 1.08, 1] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.span
        className={`${style.blob} ${style.blobB}`}
        animate={{ x: [0, -25, 0], y: [0, 25, 0], scale: [1, 1.12, 1] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className={style.inner}>
        <motion.div
          className={style.left}
          variants={container}
          initial="hidden"
          animate="show"
        >
          <motion.p className={style.available} variants={item}>
            <span className={style.pulse} />
            Open to AI automation roles
          </motion.p>

          <motion.h2 className={style.typed} variants={item}>
            <Typewriter
              options={{
                autoStart: true,
                loop: true,
                delay: 55,
                deleteSpeed: 35,
                cursor: "_",
                strings: profile.typewriter,
              }}
            />
          </motion.h2>

          <motion.h1 className={style.name} id="user-detail-name" variants={item}>
            {profile.name}
          </motion.h1>

          <motion.h1 className={style.role} id="user-detail-intro" variants={item}>
            <span className="gradText">{profile.role}</span>
          </motion.h1>

          <motion.div className={style.taglines} variants={item}>
            {profile.taglines.map((tag) => (
              <span key={tag} className={style.tag}>
                {tag}
              </span>
            ))}
          </motion.div>

          <motion.p className={style.location} variants={item}>
            <TbMapPin /> {profile.location}
          </motion.p>

          <motion.div className={style.actions} variants={item}>
            <a
              className={`resume ${style.primaryBtn}`}
              href={pdf}
              download="Akil Sadik - AI Automation Engineer"
            >
              <TbDownload /> Download Resume
            </a>
            <a href="#contact" className={style.ghostBtn}>
              Get in touch <TbArrowRight />
            </a>
          </motion.div>

          <motion.div className={style.socials} variants={item}>
            <a href={profile.githubUrl} target="_blank" rel="noreferrer" aria-label="GitHub">
              <AiFillGithub />
            </a>
            <a href={profile.linkedinUrl} target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <AiFillLinkedin />
            </a>
            <a href={`mailto:${profile.email}`} aria-label="Email">
              <AiOutlineMail />
            </a>
          </motion.div>
        </motion.div>

        {/* -------- animated automation pipeline -------- */}
        <motion.div
          className={style.right}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
        >
          <div className={style.card}>
            <div className={style.cardHead}>
              <span className={`${style.dot} ${style.dotLive}`} />
              <span className={style.dot} />
              <span className={style.dot} />
              <p className={style.cardTitle}>automation-pipeline.ts</p>
            </div>

            <div className={style.cardBody}>
              {heroFlow.map((node, ind) => (
                <div className={style.row} key={node.label}>
                  <motion.div
                    className={style.node}
                    initial={{ opacity: 0, x: -18 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 + ind * 0.16 }}
                    whileHover={{ x: 6 }}
                  >
                    <span className={style.nodeIcon}>
                      <TechIcon name={node.tech} />
                    </span>
                    <span className={style.nodeText}>
                      <span className={style.nodeLabel}>{node.label}</span>
                      <span className={style.nodeTech}>{node.tech}</span>
                    </span>
                    <span className={style.nodeIndex}>0{ind + 1}</span>
                  </motion.div>

                  {ind < heroFlow.length - 1 && (
                    <span className={style.connector}>
                      <motion.span
                        className={style.connectorFill}
                        initial={{ scaleY: 0 }}
                        animate={{ scaleY: 1 }}
                        transition={{ duration: 0.3, delay: 0.72 + ind * 0.16 }}
                      />
                      <motion.span
                        className={style.pulseDot}
                        animate={{ y: [0, 22], opacity: [0, 1, 0] }}
                        transition={{
                          duration: 1.6,
                          repeat: Infinity,
                          delay: 1.6 + ind * 0.32,
                          ease: "easeInOut",
                        }}
                      />
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </header>
  );
};

export default Home;
